module.exports = __webpack_public_path__ + "static/media/Madfit-5.aa81ee22.jpg";